
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Layout from './components/Layout';
import Dashboard from './containers/Dashboard';
import OrdersList from './containers/OrdersList';
import CreatePost from './containers/CreatePost';
import EditPost from './containers/EditPost';
import Media from './containers/Media';
import Users from './containers/Users';
import Settings from './containers/Settings';
import Login from './containers/Login';
import ContentModels from './containers/ContentModels';
import ContentItems from './containers/ContentItems';
import ContentItemForm from './containers/ContentItemForm';
import CatalogueModels from './containers/Catalogue/CatalogueModels';
import CatalogueItems from './containers/Catalogue/CatalogueItems';
import CatalogueItemForm from './containers/Catalogue/CatalogueItemForm';
import MerchantListContainer from './containers/MerchantListContainer';
import Home from './containers/Home';
import PlanOnboarding from './containers/PlanOnboarding';
import './App.css';
import Dashboard1 from './containers/Dashboard1';
import Campaign from "./containers/Campaign"
import Coupons from "./containers/Coupons"
import POSContainer from "./containers/POSContainer"
import RenewPlanContainer from './containers/RenewPlanContainer'

const PublicLayout = () => {
  
  return <Outlet />;
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="plans" element={<PlanOnboarding />} />
            <Route path="plant" element={<PlanOnboarding />} />
            <Route path="login" element={<Login />} />
          </Route>

          {/* Protected Dashboard Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard1 />} />
            <Route path="pos" element={<POSContainer />} />
            <Route path="posts" element={<OrdersList />} />
            <Route path="posts/create" element={<CreatePost />} />
            <Route path="posts/edit/:id" element={<EditPost />} />
            <Route path="content-models" element={<ContentModels />} />
            <Route path="content-models/:modelSlug" element={<ContentItems />} />
            <Route path="content-models/:modelSlug/create" element={<ContentItemForm />} />
            <Route path="content-models/:modelSlug/edit/:itemId" element={<ContentItemForm />} />
            <Route path="catalogue" element={<CatalogueModels />} />
            <Route path="catalogue/:modelId" element={<CatalogueItems />} />
            <Route path="catalogue/:modelId/create" element={<CatalogueItemForm />} />
            <Route path="catalogue/:modelId/edit/:itemId" element={<CatalogueItemForm />} />
            <Route path="media" element={<Media />} />
            <Route path="users" element={<Users />} />
            <Route path="merchantList" element={<MerchantListContainer/>} />
            <Route path="settings" element={<Settings />} />
             <Route path="campaign" element={<Campaign />} />
             <Route path="coupons" element={<Coupons />} />
             <Route path="renew-plan" element={<RenewPlanContainer />} />
              
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;